import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TargetIcon, CalendarIcon } from 'lucide-react';
const SubmitGoalPage: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    deadline: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, you would send the data to the server
    console.log('Submitting goal:', formData);
    alert('学习目标提交成功！');
    navigate('/');
  };
  return <div className="max-w-3xl mx-auto" data-id="element-1034">
      <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-1035">提交学习目标</h1>
      <div className="bg-white rounded-lg shadow p-6" data-id="element-1036">
        <form onSubmit={handleSubmit} data-id="element-1037">
          <div className="mb-6" data-id="element-1038">
            <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1039">
              目标标题
            </label>
            <div className="relative" data-id="element-1040">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1041">
                <TargetIcon size={18} className="text-gray-400" data-id="element-1042" />
              </div>
              <input type="text" id="title" name="title" value={formData.title} onChange={handleChange} className="pl-10 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" placeholder="例如：一周内完成两篇雅思作文练习" required data-id="element-1043" />
            </div>
          </div>
          <div className="mb-6" data-id="element-1044">
            <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1045">
              目标描述
            </label>
            <textarea id="description" name="description" value={formData.description} onChange={handleChange} rows={4} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" placeholder="详细描述你的学习目标内容和完成标准..." required data-id="element-1046" />
          </div>
          <div className="mb-6" data-id="element-1047">
            <label htmlFor="deadline" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1048">
              截止日期
            </label>
            <div className="relative" data-id="element-1049">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1050">
                <CalendarIcon size={18} className="text-gray-400" data-id="element-1051" />
              </div>
              <input type="date" id="deadline" name="deadline" value={formData.deadline} onChange={handleChange} className="pl-10 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" required data-id="element-1052" />
            </div>
          </div>
          <div className="flex justify-end" data-id="element-1053">
            <button type="button" onClick={() => navigate('/')} className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors mr-4" data-id="element-1054">
              取消
            </button>
            <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1055">
              提交目标
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default SubmitGoalPage;